import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, ArrowRight, Truck, MapPin, Wrench } from 'lucide-react';

const ELDERS_LOGO =
  'https://customer-assets-wrfwihn1.emergentagent.net/job_a0e7f17d-9159-4d2a-a971-2aaa914eeb6a/artifacts/p12muae5_image.png';

const items = [
  { icon: Truck, label: 'Machinery & load cover' },
  { icon: MapPin, label: 'Any radius, any state' },
  { icon: Wrench, label: 'Attachments included' },
  { icon: ShieldCheck, label: 'Broker-backed quote' },
];

const InsuranceQuotesStrip = () => {
  return (
    <section className="bg-gray-50 py-8 sm:py-12 md:py-16" data-testid="insurance-quotes-strip">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-[#c8102e] via-[#dc2626] to-[#8b0f1e] text-white">
          <div
            className="absolute -top-16 -right-16 w-64 h-64 bg-white/20 rounded-full blur-3xl"
            aria-hidden
          />
          <div
            className="absolute -bottom-16 -left-16 w-64 h-64 bg-[#1e3a5f]/30 rounded-full blur-3xl"
            aria-hidden
          />

          <div className="relative grid md:grid-cols-[1.2fr_1fr] gap-6 md:gap-8 p-5 sm:p-8 md:p-10 items-center">
            <div>
              <span className="inline-block bg-white text-red-700 text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow mb-2 md:mb-3">
                Insure your load
              </span>
              <h2 className="text-xl sm:text-2xl md:text-4xl font-bold leading-tight mb-2 md:mb-3">
                Insurance for heavy machinery &amp; oversize loads.
              </h2>
              <p className="text-red-50 text-sm md:text-base mb-4 md:mb-5 max-w-lg">
                Truckn Send It has partnered with{' '}
                <span className="font-semibold text-white">Elders Insurance</span> to get you a
                quick, no-obligation quote on the gear you&apos;re moving — same business day.
              </p>
              <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-6 max-w-lg">
                {items.map((i) => {
                  const Icon = i.icon;
                  return (
                    <div
                      key={i.label}
                      className="flex items-center gap-2 text-sm bg-white/15 backdrop-blur-sm rounded-lg px-3 py-2"
                    >
                      <Icon className="w-4 h-4 text-white flex-shrink-0" />
                      <span className="font-medium">{i.label}</span>
                    </div>
                  );
                })}
              </div>
              <Link
                to="/insurance-quotes"
                className="inline-flex items-center gap-2 bg-white hover:bg-red-50 text-red-700 font-semibold px-5 py-3 rounded-full shadow-lg transition-all hover:shadow-xl"
                data-testid="home-insurance-cta"
              >
                Get my insurance quote
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>

            <div className="hidden md:flex justify-center">
              <div className="bg-white rounded-2xl p-6 shadow-xl text-center max-w-[240px]">
                <p className="text-[10px] font-bold uppercase tracking-widest text-red-700 mb-3">
                  In partnership with
                </p>
                <img
                  src={ELDERS_LOGO}
                  alt="Elders Insurance"
                  className="mx-auto max-h-20 object-contain"
                />
                <p className="mt-3 text-[11px] text-gray-500 leading-relaxed">
                  Quotes issued by licensed Elders Insurance brokers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InsuranceQuotesStrip;
